export default (params) => ({
  trigger: {
    name: 'last_order_block.click_product_support',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'select_item_support',
      params: {
        sub_feature: null,
      },
    },
  },
});
